// HelpPopover —— 表单输入项的「?」说明按钮
//
// 用法:
//   <Label htmlFor="x" required>
//     用户名 <HelpPopover content="登录用的唯一标识…" />
//   </Label>
//
// 或直接在工具栏搜索框旁:
//   <Input ... />
//   <HelpPopover content="按仓库名或描述模糊搜索,留空显示全部。" />
//
// 设计要点:
//   - 用 Fluent UI v9 的 TeachingPopover,点击「?」弹出说明卡片。
//   - type="button":避免放在 <form> 内时误触发表单提交。
//   - onMouseDown preventDefault:点击「?」时不抢走关联输入框的焦点。
import { type ReactNode } from 'react';
import {
  makeStyles,
  tokens,
  Button,
  TeachingPopover,
  TeachingPopoverBody,
  TeachingPopoverSurface,
  TeachingPopoverTitle,
  TeachingPopoverTrigger,
} from '@fluentui/react-components';
import { QuestionCircleRegular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  trigger: {
    width: '20px',
    height: '20px',
    minWidth: '20px',
    padding: '0',
    marginLeft: '4px',
    color: tokens.colorNeutralForeground3,
    verticalAlign: 'middle',
    borderRadius: tokens.borderRadiusCircular,
    ':hover': {
      color: tokens.colorBrandForeground1,
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
    ':active': {
      color: tokens.colorBrandForeground1,
    },
  },
  surface: {
    maxWidth: '340px',
  },
  body: {
    fontSize: tokens.fontSizeBase300,
    lineHeight: tokens.lineHeightBase300,
    color: tokens.colorNeutralForeground2,
  },
});

export function HelpPopover(props: {
  title?: string;
  content: ReactNode;
  ariaLabel?: string;
}) {
  const styles = useStyles();
  return (
    <TeachingPopover>
      <TeachingPopoverTrigger>
        <Button
          type="button"
          icon={<QuestionCircleRegular />}
          appearance="transparent"
          size="small"
          className={styles.trigger}
          aria-label={props.ariaLabel ?? '查看说明'}
          title="说明"
          onMouseDown={(e) => e.preventDefault()}
        />
      </TeachingPopoverTrigger>
      <TeachingPopoverSurface className={styles.surface}>
        {props.title && <TeachingPopoverTitle>{props.title}</TeachingPopoverTitle>}
        <TeachingPopoverBody className={styles.body}>{props.content}</TeachingPopoverBody>
      </TeachingPopoverSurface>
    </TeachingPopover>
  );
}
